import "./App.css"
import { Routes, Route, Navigate, Outlet } from "react-router-dom"
import { Login } from "@/components/Login"
import { Register } from "@/components/Register"
import { Home } from "@/components/Home"
import { RoleDashboard } from "@/components/RoleDashboard"
import { ModuleTwoAffiliateDashboard } from "@/components/ModuleTwoAffiliateDashboard"
import { AdminReviewDashboard } from "@/components/AdminReviewDashboard"
import { getSession } from "@/lib/auth"

const ROLE_PATHS = {
  affiliate: "/affiliate/dashboard",
  administrator: "/admin/dashboard",
  system_admin: "/system-admin/panel",
}

function getRolePath(role) {
  return ROLE_PATHS[role] || "/login"
}

function PublicOnlyRoute() {
  const session = getSession()
  return session ? <Navigate to={getRolePath(session.role)} replace /> : <Outlet />
}

function ProtectedRoute({ allowedRoles }) {
  const session = getSession()

  if (!session) {
    return <Navigate to="/login" replace />
  }

  if (allowedRoles && !allowedRoles.includes(session.role)) {
    return <Navigate to={getRolePath(session.role)} replace />
  }

  return <Outlet />
}

import { SystemAdminDashboard } from "@/components/SystemAdminDashboard"

function App() {
  return (
    <div className="app-shell">
      <Routes>
        <Route path="/" element={<Home />} />

        <Route element={<PublicOnlyRoute />}>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["affiliate"]} />}>
          <Route
            path="/affiliate/dashboard/*"
            element={<ModuleTwoAffiliateDashboard />}
          />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["administrator"]} />}>
          <Route path="/admin/dashboard/*" element={<AdminReviewDashboard />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["system_admin"]} />}>
          <Route path="/system-admin/panel/*" element={<SystemAdminDashboard />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  )
}

export default App
